import { useQuery } from '@apollo/client';
import React from 'react';
import { SortDirection, generatedTypesNew } from '@css-xp/graphtypes';
import { fetchInvoicesForInvoiceGroupPage } from './queries/fetch-invoices-for-invoice-group';
import { fetchPaymentMethodsForInvoiceGroup } from './queries/fetch-payment-methods-for-invoice-group';
import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';
import InvoiceTabIG from './invoice-tab-ig';

interface InvoiceTabProps {
  id: string;
  transactionAccountId?: string;
  label?: string;
  showHeading?: boolean;
}

const sortOptions = {
  sortFields: ['createdDate', 'id'],
  sortFieldsDirections: [SortDirection.DESC, SortDirection.DESC],
};

export const InvoiceTab = ({ id, transactionAccountId, label, showHeading = false }: InvoiceTabProps) => {
  const { refetch, loading, error, data } = useQuery<
    generatedTypesNew.FetchInvoicesForInvoiceGroupPageV2Query,
    generatedTypesNew.FetchInvoicesForInvoiceGroupPageV2QueryVariables
  >(fetchInvoicesForInvoiceGroupPage, {
    variables: {
      id: id,
      searchOptions: {
        first: DEFAULT_ROWS_PER_PAGE,
        sort: { ...sortOptions },
      },
    },
    nextFetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const { data: paymentMethodsData } = useQuery<
    generatedTypesNew.FetchPaymentMethodsForInvoiceGroupQuery,
    generatedTypesNew.FetchPaymentMethodsForInvoiceGroupQueryVariables
  >(fetchPaymentMethodsForInvoiceGroup, {
    variables: {
      id: id,
    },
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });

  // variables to use for paging and populating our template
  const totalCount = data?.invoiceGroup?.invoices?.totalCount ?? 0;
  const nodes = data?.invoiceGroup?.invoices?.nodes;
  const availablePaymentMethods = paymentMethodsData?.invoiceGroup?.availablePaymentMethods?.nodes;

  return (
    <InvoiceTabIG
      transactionAccountId={transactionAccountId}
      nodes={nodes}
      totalRecords={totalCount}
      loading={loading}
      error={error}
      refetch={refetch}
      label={label}
      availablePaymentMethods={availablePaymentMethods}
      showHeading={showHeading}
    />
  );
};

export default InvoiceTab;
